/* eslint-disable no-underscore-dangle */
import { Button } from "@chakra-ui/react";

export default function KlaviyoOutdoorCouncilOffer() {
  return (
    <Button
      id="form-claim-offer"
      bg="brand.500"
      color="white"
      _hover={{ bg: "brand.600" }}
      size="md"
      onClick={() => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(["openForm", "VppTBi"]);
      }}
    >
      Claim My Offer
    </Button>
  );
}
